import {gsap} from "gsap";

let bgVideo = promokit.video({
  el: '.section-1__bg-video',
  url: 'https://vod.plaync.com/lineage/remaster/Lineage_remastered_lancer_main.mp4',
  loop: true,
  mute: true,
  preload: true
});

let video1 = promokit.youtube({
    el: '.section-1__layer-1-player-1',
    youtubeid: 'NCohdUfJ570',
    controls: true,
    mute: false
});

let video2 = promokit.youtube({
    el: '.section-1__layer-2-player-1',
    youtubeid: '4zuXdkWHcqY',
    controls: true,
    mute: false
});


let layer1 = promokit.layer({
    el: '#section-1__layer-1',
    buttons: '.section-1__btn-movie',
    render: true,
    modifier: 'slide',
    esc: true,
    autoplayVideo: video1
});

let layer2 = promokit.layer({
    el: '#section-1__layer-2',
    buttons: '.section-1__btn-music',
    render: true,
    modifier: 'slide',
    esc: true,
    autoplayVideo: video2
});

const mountAnimation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('.section-1__logo', {opacity: 0, scale: 8, duration: .2}, 'start+=1.9')
    .from('.section-1__disc', {opacity: 0, width:'0', duration: .4}, 'start+=2.3')
    .from('.section-1__date', {opacity: 0, width: '0', duration: .8,ease: "power1.out"}, 'start+=2.6')
    .from('.section-1__btn-movie', {opacity: 0, y: '+=30', duration: .6}, 'start+=3.8')
    .from('.section-1__btn-music', {opacity: 0, y: '+=30', duration: .6}, 'start+=3.8')
    .from('.section-1__scroll', {opacity: 0, y: '+=30', duration: .6}, 'start+=4')
    .from('.section-1__utile', {opacity: 0, y: '+=30', duration: .6}, 'start+=4.1')
    .staggerFrom(
        '.section-1__logo i',
        0.6, {scale:.7, opacity:0, rotation: 0, ease: "power2.out",}, 0.1, 'start+=2.7', function(){
          $('.section-1__logo').addClass('ani-active');
        })



export default {
  id: '#section-1',
  name:'Main',
  backgroundVideo: bgVideo,
    mainLayer1: layer1,
    mainLayer2: layer2,

  enterStart() {
    mountAnimation.play();
  }
};



// WEBPACK FOOTER //
// ./src/js/pc/section-1.js